<template>
    <a @click="toggleBookmark" rel="preload" class="bookmark-btn" :class="{product: request === 'product_id', title: title}">
        <div class="bookmark-btn__btn" 
            :class="{active: is_bookmark}">
            <svg v-if="title" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path class="first" d="M4.94141 20.938V3.05913C4.94141 2.99412 4.99408 2.94141 5.05905 2.94141H18.9414C19.0064 2.94141 19.0591 2.99412 19.0591 3.05914V20.938C19.0591 21.0378 18.9427 21.0923 18.8661 21.0284L12.0002 15.3029L5.13437 21.0284C5.05774 21.0923 4.94141 21.0378 4.94141 20.938Z" fill="#9D9D9D"/>
                <path class="first" fill-rule="evenodd" clip-rule="evenodd" d="M5.88235 3.88366V19.1789L12 14.0774L18.1176 19.1789V3.88366H5.88235ZM4 3.05956C4 2.47437 4.47406 2 5.05882 2H18.9412C19.526 2 20 2.47439 20 3.05956V20.9384C20 21.8368 18.953 22.3275 18.2633 21.7524L12 16.5293L5.73667 21.7524C5.04703 22.3275 4 21.8368 4 20.9384V3.05956Z" fill="#9D9D9D"/>
            </svg>
            <svg v-else-if="request === 'offer_id'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path class="first" fill-rule="evenodd" clip-rule="evenodd" d="M6.64706 4.39549V18.1612L12 13.5698L17.3529 18.1612V4.39549H6.64706ZM5 3.6538C5 3.12713 5.4148 2.7002 5.92647 2.7002H18.0735C18.5852 2.7002 19 3.12715 19 3.6538V19.7448C19 20.5533 18.0839 20.9949 17.4804 20.4773L12 15.7766L6.51958 20.4773C5.91615 20.9949 5 20.5533 5 19.7448V3.6538Z" fill="#C9C9C9"/>
                <path class="second" d="M6.64706 18.1612V4.39549H17.3529V18.1612L12 13.5698L6.64706 18.1612Z" fill="#C9C9C9"/>
            </svg>
            <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path class="first" fill-rule="evenodd" clip-rule="evenodd" d="M6.64706 4.39549V18.1612L12 13.5698L17.3529 18.1612V4.39549H6.64706ZM5 3.6538C5 3.12713 5.4148 2.7002 5.92647 2.7002H18.0735C18.5852 2.7002 19 3.12715 19 3.6538V19.7448C19 20.5533 18.0839 20.9949 17.4804 20.4773L12 15.7766L6.51958 20.4773C5.91615 20.9949 5 20.5533 5 19.7448V3.6538Z" fill="#9D9D9D"/>
                <path class="second" d="M6.64706 18.1612V4.39549H17.3529V18.1612L12 13.5698L6.64706 18.1612Z" fill="#9D9D9D"/>
            </svg>
        </div>

        <div v-if="title" class="bookmark-btn__text" :class="{active: is_bookmark}">
            <span>
                {{ is_bookmark ? $t('Remove Bookmark') : $t('Add to Bookmarks') }}
            </span>
        </div>
    </a>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        requestId: {
            type: Number,
            required: true
        },
        is_bookmark: {
            type: Boolean,
            required: true
        },
        request: {
            type: String,
            required: true,
        },
        title: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    emits: ['update:bookmark'],
    methods: {
        toggleBookmark() {
            const newBookmarkState = !this.is_bookmark;
            this.$emit('update:bookmark', { id: this.requestId, newStatus: newBookmarkState });
            axios.get(`/${window.common.language.code2}/bookmark/toggle?${this.request}=${this.requestId}`, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                })
                .then(() => {
                })
                .catch(error => {
                    this.$emit('update:bookmark', { id: this.requestId, newStatus: this.is_bookmark });
                    console.error('Error toggling bookmark:', error);
                    return;
                });
            
            const indicator = document.querySelector('.js-count-informer-bookmark');
            if (indicator) {
                const currentValue = Number(indicator.textContent) || 0;
                const newValue = newBookmarkState ? currentValue + 1 : currentValue - 1;

                indicator.textContent = newValue;
                if(newValue > 0) {
                    document.querySelector('.js-bookmark-item')?.classList.add('view-informer');
                    document.querySelector('.js-bookmark-item .header-inner__nav-container')?.classList.add('js-bookmarks-url');
                } else {
                    document.querySelector('.js-bookmark-item')?.classList.remove('view-informer');
                    document.querySelector('.js-bookmark-item .header-inner__nav-container')?.classList.remove('js-bookmarks-url');
                }
            }
        }
    }
};
</script>

<style scoped lang="scss">
    .bookmark-btn{
        display: flex;
        gap: 15px;
        align-items: center;
        &:hover{
            .bookmark-btn__text span{
                color: #4E8AFF;
            }
            .bookmark-btn__btn{
                .first{
                    fill: #4E8AFF;
                }
                .second{
                    fill: #fff;
                }
                &.active{
                    .first{
                        fill: #4E8AFF;
                    }
                    .second{
                        fill: #4E8AFF;
                    }
                }
                
            }
            &.title{
                background-color: #4E8AFF1A;
                .second{
                    fill: #4E8AFF1A;
                }
            }
        }
        &.title{
            background-color: #fff;
            height: 55px;
            width: 100%;
            transition: 0.4s;
            padding: 10px 20px;
        }
        
        &__btn{
            display: flex;
            align-items: center;
            justify-content: center;
            .first,
            .second{
                transition: 0.4s;
            }
            .first{
                fill: #9D9D9D;
            }
            .second{
                fill: #fff;
            }
            &.active{
                .first{
                    fill: #4E8AFF;
                }
                .second{
                    fill: #4E8AFF;
                }
            }
        }
        &__text{
            span{
                font-family: "Avenir-Next", sans-serif;
                font-weight: 400;
                font-size: 16px;
                line-height: 24px;
                letter-spacing: 0px;
                color: #9D9D9D;
                transition: 0.4s;
            }
            &.active span{
                color: #4E8AFF;
            }
        }
        &.product{
            align-items: flex-start;
            svg{
                width: 32px;
                height: 32px;
            }
        }
    }
</style>